/**
 * jenky way to wrap eval in a function that allows esbuild to mangle var names,
 * avoiding the `direct-eval` warn rule. It also limits access of eval to what
 * we explicitly allow.
 *
 * Note: this is temporary until evaluation is moved server-side
 */
const runScript = new Function(
    "__jsCode__",
    "allowedNames",
    "disallowedChars",
    "disallowedArray",
    "variableOverwrites",
    "codeStr",
    "thisObj",
    "ExecutionEnvironment",
    `"use strict";\nreturn eval(__jsCode__);`,
);

function isValidStrictStatement(statement: string) {
    try {
        new Function(`"use strict"; ${statement}`);
        return true;
    } catch (caughtError) {
        return false;
    }
}

export class ExecutionEnvironment {
    public static run(codeStr: string, thisObj: any) {
        const allowedNames: any = { eval: true, setTimeout: true, console: true, Date: true };
        const disallowedChars = " !@#%^&*()+-=\\<>.?:;|{}[],\"'";
        const disallowedArray = disallowedChars.split("");

        const variableOverwrites = ["XMLHttpRequest", "ActiveXObject"]
            .concat(Object.keys(window))
            .filter((name) => !allowedNames[name] && !disallowedArray.some((char) => name.includes(char)))
            .map((name) => "var " + name + " = undefined; ")
            .filter(isValidStrictStatement)
            .join("");

        let __jsCode__ =
            variableOverwrites +
            "let $pro = this; " +
            "let __execStartDate__ = new Date(); " +
            "let __terminate__ = function() { return ((new Date()) - __execStartDate__) / 1000 > 3; }; " +
            "var setTimeout = undefined; " +
            codeStr;
        __jsCode__ = __jsCode__.replace(/(eval\s*\(.*?\);)/g, "console.log('Cannot use eval');");
        __jsCode__ = __jsCode__.replace(/(while\s*\(.*?\)\s*{)/g, "$1 if(__terminate__()) { break; } ");
        __jsCode__ = __jsCode__.replace(/(do\s*{)/g, "$1 if(__terminate__()) { break; } ");
        __jsCode__ = __jsCode__.replace(/(for\s*\(.*?\)\s*{)/g, "$1 if(__terminate__()) { break; } ");

        return runScript.call(
            thisObj,
            __jsCode__,
            allowedNames,
            disallowedChars,
            disallowedArray,
            variableOverwrites,
            codeStr,
            thisObj,
            ExecutionEnvironment,
        );
    }
}
